// extracted by mini-css-extract-plugin
export default {"wrapper":"login_wrapper__+pkT0","redirectLogin":"login_redirectLogin__v8mc4"};